import * as Actions from '../constant/ActionTypes';

const ackReducers = (ack={responseCode: 500}, action) => {
    switch(action.type) {
        case Actions.ACK:
            return action.payload;

        default :
        return ack;
    }
}
export default ackReducers;